'use client';

import { isNonDefaultFacetApplied } from '../SearchResultsFacets/utils';

import { useSearchContext } from '@/services/search/SearchProvider';
import { useQueryParams } from '@nxt-costco-com/forge-digital-components';

import { FilterAwareVisibilityToggleProps } from './FilterAwareVisibilityToggle.types';

export default function FilterAwareVisibilityToggle({
    children,
    region,
    showAdsAboveFilteredResults = false,
}: FilterAwareVisibilityToggleProps) {
    const { queryParams: searchParams } = useQueryParams();
    const { searchService } = useSearchContext();
    // If query params condition satisfied and above grid, do not display.
    const shouldHideChildren =
        isNonDefaultFacetApplied(searchParams, searchService) &&
        region === 'AboveGrid' &&
        !showAdsAboveFilteredResults;
    if (shouldHideChildren) {
        return null;
    }

    return <>{children}</>;
}
